import { render, staticRenderFns } from "./ExpandableDetails.vue?vue&type=template&id=48146838"
import script from "./ExpandableDetails.vue?vue&type=script&lang=js"
export * from "./ExpandableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports